import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/horizon/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/horizon/topics' });
  },
});
